import React from "react";

export default function MainContent(props) {
  const title = props.title;
  const content = props.content;
  const hideHeader = props.hideHeader;

  return (
    <div className="content-wrapper">
      <section className="content pt-3">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-primary card-outline">
                {!hideHeader ? (
                  <div className="card-header">
                    <div className="card-title">{title}</div>
                  </div>
                ) : null}
                <div className="card-body">{content}</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
